import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/landing';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section id="faq" className="bg-cream-deep py-14 sm:py-20" data-id="element-25" data-mp="1bmlmp7radxkh">
      <div className="mx-auto max-w-3xl px-5 sm:px-8" data-id="element-26" data-mp="1gkn6juwje0x0">
        <h2 className="text-center font-display text-3xl font-semibold leading-tight tracking-tight text-petrol sm:text-4xl" data-id="element-27" data-mp="24969rw0qbni8">
          Preguntas frecuentes
        </h2>

        <ul className="mt-9 space-y-2.5" data-id="element-28" data-mp="28a0354wxxuii">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <li key={faq.question} className="overflow-hidden rounded-2xl bg-white shadow-card" data-id="element-29" data-mp="1zi7r4ps9qdbt" data-mpi={i}>
                <h3 data-id="element-30" data-mp="2n7imfrqunfik">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors duration-150 ease-soft hover:bg-cream/60 sm:px-6" data-id="element-31" data-mp="2n70tb3zhhhev">
                    <span className="font-sans text-[15px] font-semibold text-petrol sm:text-base" data-id="element-32" data-mp="1elvhg56qj1us">
                      {faq.question}
                    </span>
                    <ChevronDownIcon className={`h-4 w-4 shrink-0 text-petrol-muted transition-transform duration-200 ease-soft ${isOpen ? 'rotate-180' : ''}`} strokeWidth={2.4} aria-hidden="true" data-id="element-33" data-mp="1oj19pgr34ywl" />
                  </button>
                </h3>

                <AnimatePresence initial={false} data-id="element-34" data-mp="1sj1ztynjqyjh">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-35" data-mp="3813puve46i8">
                      <p className="px-5 pb-5 font-sans text-[15px] leading-relaxed text-petrol/75 sm:px-6" data-id="element-36" data-mp="289dm9cxikxdw">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}